// src/features/results/resultSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getAssessmentById = createAsyncThunk(
  "results/getAssessmentById",
  async (_id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/studentDummy/test/get-details?assessment=${_id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const assessmentSlice = createSlice({
  name: "assessmentDetails",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAssessmentById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAssessmentById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getAssessmentById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default assessmentSlice.reducer;
